import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IMember } from "types";

type AuthState = {
  isAuthed: boolean;
  member?: IMember;
};

type InitialState = {
  data: AuthState;
};

const initialState: InitialState = {
  data: { isAuthed: false, member: undefined },
};

const slice = createSlice({
  name: "routeAuthState",
  initialState: initialState,
  reducers: {
    setRouteAuthState: (state, action: PayloadAction<Partial<AuthState>>) => {
      state.data = { ...state.data, ...action.payload };
    },
    setRouteAuthMember: (state, action: PayloadAction<IMember>) => {
      state.data = { ...state.data, member: action.payload };
    },
    clearRouteAuthState: (state) => {
      state.data = { ...initialState.data };
    },
  },
});

export const {
  reducer,
  actions: { setRouteAuthState, clearRouteAuthState, setRouteAuthMember },
} = slice;
